export default {
  'appointment-request.status': 'Status of your appointment request',
  'appointment-request.send': 'Send request',
  'appointment-request.title': 'Appointment request | {appointmentType}',
  'cancel-appointment-request.title': 'Appointment request cancellation',
  'appointment-request-cancel': 'Cancel appointment request',
  'cancel-appointment-request.reason':
    'Please tell us why you want to cancel your appointment request',
  'appointment-request.reason-for-cancellation': 'Reason for cancellation: {reason}',
  'appointment-request.reason-for-rejection': 'Reason: {reason}',
  'appointment-request.reason-for-archived': 'Reason for archived: {reason}',
  'appointment-request.reason-for-cancellation.missing': 'No reason given',

  'appointment-request-account-verification': 'Confirm appointment request',
  'appointment-request-account-verification.description':
    'Your appointment request has been successfully created. Please confirm your account to complete the appointment request. We have sent you an email to the email address {email}. Please note that your appointment request is valid for another 15 minutes. If you do not verify your account, it will be automatically deleted.',

  'appointment-request': 'Appointment request',
  'appointment-request.addition': 'Your comments',
  'appointment-request.appointments': 'Linked appointments',
  'appointment-request.description':
    'You will receive an email from the selected facility after completing the appointment request, from which you can complete your appointment booking..',
  'appointment-request.manual':
    'Your appointment request will be processed manually by the facility. The response to your request may take a few days as a result.',
  'appointment-request.confirm': 'Send appointment request',
  'appointment-request.error': 'Appointment request failed',
  'appointment-request.success': 'Appointment request sent',
  'appointment-request.success.description':
    'You can view and manage your appointment requests as well as already booked appointments in the appointment overview.',
  'appointment-request.error.description':
    'An unexpected error occurred while requesting an appointment. Please try again.',
};
